export default __webpack_public_path__ + "static/media/product1.8d05cbf9.jpg";